import { useEffect } from "react"

type KeyboardNavigatorGroupProps = {}

export function KeyboardNavigationHelper(props: KeyboardNavigatorGroupProps) {
  useEffect(() => {
    function getGroup(target: HTMLElement) {
      let parent = target.parentElement
      while (parent) {
        if (parent.hasAttribute("data-keyboard-group")) {
          return parent as HTMLElement
        }
        parent = parent.parentElement
      }
      return null
    }
    function getAccessible(target: HTMLElement) {
      if ("checkVisibility" in target && target.checkVisibility() === false) {
        return false
      }
      let parent = target.parentElement
      while (parent) {
        if (parent.ariaDisabled || parent.ariaHidden) {
          // console.log("Not visible", parent)
          return false
        }
        parent = parent.parentElement
      }
      return true
    }

    const onKeydown = (e: KeyboardEvent) => {
      const target = document.activeElement as HTMLElement
      if (!target || target instanceof HTMLElement === false) return
      if (!target?.hasAttribute("data-keyboard-navigable")) return

      const keyDir =
        e.key === "ArrowDown"
          ? "down"
          : e.key === "ArrowUp"
            ? "up"
            : e.key === "ArrowLeft"
              ? "left"
              : e.key === "ArrowRight"
                ? "right"
                : null
      if (!keyDir) return

      const group = getGroup(target)
      const cycles = !!group
      const elements = (group ?? document.body).querySelectorAll("[data-keyboard-navigable]")
      const index = Array.from(elements).indexOf(target)

      if (index !== -1) {
        const dir = keyDir === "down" || keyDir === "right" ? 1 : -1
        let nextIndex = index
        for (let i = 0; i < elements.length; i++) {
          nextIndex += dir
          const next = elements[cycles ? (nextIndex + elements.length) % elements.length : nextIndex]
          if (next instanceof HTMLElement && getAccessible(next)) {
            // console.log("Focus", next, nextIndex)
            e.preventDefault()
            next.focus()
            return
          }
        }
      }
    }

    document.addEventListener("keydown", onKeydown)
    return () => {
      document.removeEventListener("keydown", onKeydown)
    }
  }, [])

  return null
}
